import axios from 'axios'
import './axiosConfig'

const API_BASE_URL = import.meta.env.VITE_API_URL

export type Site = {
  siteId: number
  siteName: string
  isDefault: boolean
  armCount?: number
}

import { getConsumers } from './consumerService'
import { debugLog } from '@/utils/debugLog'

// The sites the signed-in user may open, without the per-site consumer count.
// Callers that only need names and ids (a picker, a filter) must use this and
// not getSites, which costs one extra request per site.
export const getSiteOptions = async (): Promise<Site[]> => {
  const res = await axios.get(`${API_BASE_URL}/api/user/sites`)
  const payload = res.data?.data ?? res.data
  return Array.isArray(payload) ? payload : []
}

export const getSites = async (): Promise<Site[]> => {
  try {
    const payload = await getSiteOptions()
    debugLog("[SiteSelection] Fetched sites details:", payload)

    return await Promise.all(
      payload.map(async (site: Site) => {
        try {
          const result = await getConsumers({ accountId: site.siteId, page: 1, size: 1 })
          return {
            ...site,
            armCount: result.total,
          }
        } catch (err) {
          console.error(`Failed to fetch count for site ${site.siteId}:`, err)
          return {
            ...site,
            armCount: 0,
          }
        }
      })
    )
  } catch (err) {
    console.error("[SiteSelection] Failed to fetch sites:", err)
    return []
  }
}

export type PostAuthDestination = { path: string; site?: Site }

// Decide where to send the user immediately after authentication.
// Exactly one site -> go straight there. More than one (or none) -> show the
// Site List so the user chooses. is_default is only used to highlight/pre-select
// in the list, never to auto-skip it.
export const resolvePostAuthDestination = async (): Promise<PostAuthDestination> => {
  try {
    const sites = await getSites()
    if (sites.length === 1) return { path: `/${sites[0].siteId}/home`, site: sites[0] }
    return { path: '/sites' }
  } catch {
    return { path: '/sites' }
  }
}





